import { ICarePlanMedication } from '~/services/api/carePlanMedications/types';

const getInitialValues = (carePlanMedication: ICarePlanMedication) => ({
  ...carePlanMedication,
  id: carePlanMedication.id ?? 0,
  name: carePlanMedication.name ?? '',
  reason: carePlanMedication.reason ?? '',
  startDate: carePlanMedication.startDate ?? null,
  endDate: carePlanMedication.endDate ?? null,
});

export default getInitialValues;
